import React from 'react';
import { Box, CoveragePeriods, ElectionAmount, Text } from '@common-fe/common-fe';

import CoveragePeriodsTable from '../../Employee/EnrollmentBalances/components/CoveragePeriodsTable';
import ElectionAmountTable from '../../Employee/EnrollmentBalances/components/ElectionAmountTable';
import EnrollmentStatusesTable from '../../Employee/EnrollmentBalances/components/EnrollmentStatusesTable';
import useGetPolicyStatusesQuery from '../queries/useGetPolicyStatuses.query';

interface Props {
  coveragePeriods?: CoveragePeriods[];
  policyId?: string;
  externalDeductibleMet?: string;
  electionPeriods?: ElectionAmount[];
}

export const EnrollmentDetailsEnrollmentStatusHistory: React.FC<Props> = ({
  coveragePeriods,
  policyId,
  externalDeductibleMet,
  electionPeriods,
}) => {
  const { statuses } = useGetPolicyStatusesQuery(policyId);
  return (
    <Box>
      <Box direction="row" width="100%" justify="between">
        {!!statuses?.length && (
          <Box
            background="canvas"
            pad={{ bottom: 'xs', horizontal: 'm', top: 'm' }}
            round="container1Round"
            border={{ size: '1px', color: 'border2' }}
            margin={{ right: coveragePeriods?.length ? 'm' : '0' }}
            width="100%"
            height="fit-content"
          >
            <Text size="small" weight="bold" color="textTitle" margin={{ bottom: 'xs' }}>
              Enrollment status history
            </Text>
            <EnrollmentStatusesTable statuses={statuses} />
          </Box>
        )}
        {!!coveragePeriods?.length && (
          <Box
            background="canvas"
            pad={{ bottom: 'xs', horizontal: 'm', top: 'm' }}
            round="container1Round"
            width="100%"
            border={{ size: '1px', color: 'border2' }}
            height="fit-content"
          >
            <Text size="small" weight="bold" color="textTitle" margin={{ bottom: 'xs' }}>
              All coverage periods
            </Text>
            <CoveragePeriodsTable
              coveragePeriods={coveragePeriods}
              externalDeductibleMet={externalDeductibleMet}
            />
          </Box>
        )}
      </Box>

      {!!electionPeriods?.length && (
        <Box
          background="canvas"
          pad={{ bottom: 'xs', horizontal: 'm', top: 'm' }}
          margin={{ top: 'm' }}
          round="container1Round"
          border={{ size: '1px', color: 'border2' }}
          width="100%"
          height="fit-content"
        >
          <Text size="small" weight="bold" color="textTitle" margin={{ bottom: 'xs' }}>
            All election amounts
          </Text>
          <ElectionAmountTable electionPeriods={electionPeriods} />
        </Box>
      )}
    </Box>
  );
};
